<template>
  <div class="day_arrange">
    <el-table
      :data="list"
      style="width: 100%; margin-bottom: 20px; text-align: center"
      row-key="id"
      border
      :cell-style="cellStyleFn"
      default-expand-all
      :show-header="false"
      :tree-props="{ children: 'childArr', hasChildren: 'hasChildren' }"
    >
      <el-table-column>
        <template slot-scope="{ row }">
            <!-- type：1普通节点 2面授课 3签到 4作业 5问卷 6资源 40自定义 -->
         <div class="box">
             <span>{{row.name?row.name:row.title}}</span>
             <span v-if="row.type != 40 && row.des != undefined">（考核数量{{row.check_num}}）</span>
             <!-- 提示语 -->
             <i class="el-icon-question c-success fs16 ml6 icon" v-if="row.type == 3">
              <div class="update-info">
                <p>提示：迟到/早退扣{{datas.late_min_score}}分；缺勤扣{{datas.lack_min_score}}分，请假扣{{datas.leave_min_score}}分</p>
              </div>
            </i>
            <i class="el-icon-question c-success fs16 ml6 icon" v-if="row.type == 6">
              <div class="update-info">
                <p>提示：观看全部或下载即得满分</p>
              </div>
            </i>
         </div>
        </template>
      </el-table-column>
      <el-table-column width="150">
        <template slot-scope="{ row }">
          <span v-if="row.score != undefined && row.score !== ''" >{{row.score}} 分</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// import {previewOffice } from '@/api/student'
export default {
  props: {
    list: {
      type: Array,
    },
    datas: {
      type: Object,
    },
  },
  data() {
    return {
        arr:[]
    };
  },
  methods: {
    // 修改某一列单元样式
    cellStyleFn({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return `text-align:left;`;
      }
    },
  },
  filters: {
    // // 过滤时间
    // filterTime(val) {
    //   let startArr = val.start_date.split(" ");
    //   let endArr = val.end_date.split(" ");
    //   let str = `${startArr[0]} ${startArr[1]}-${endArr[1]}`;
    //   let str2 = `${startArr[0]}~${endArr[0]}`;
    //   if (val.type == 5 || val.type == 6) {
    //     return str2;
    //   } else {
    //     return str;
    //   }
    // },
  },
};
</script>
 
<style lang = "less" scoped>
.day_arrange {
  /deep/ .el-table {
    td {
      text-align: center;
    }
    /* 二级节点 */
    .el-table__row--level-1 {
      td {
        .cell {
          display: flex;
          justify-content: center;
        }
        &:first-child {
          .cell {
            justify-content: flex-start;
          }
        }
      }
    }
    .el-tag {
      margin-left: 6px;
    }
    /* 一级节点 */
    .el-table__row--level-0 {
      td {
        .cell {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &:first-child {
          .cell {
            justify-content: flex-start;
          }
        }
      }
    }
    .el-table__row {
      cursor: pointer;
    }
    .box{
         .icon {
        cursor: pointer;

        .update-info {
          display: none;
          /* width: 238px; */
          color: #334343;
          text-align: left;
          position: absolute;
          top: 4px;
          left: 185px;
          padding: 8px 6px;
          font-size: 12px;
          border-radius: 4px;
          line-height: 22px;
          border: 1px solid #ccc;
          background-color: #f9f9f9;
        }

        &:hover {
          .update-info {
            display: block;
          }
        }
      }
    }
  }
}
</style>